import React, { useState } from 'react';
import { StarIcon, ChevronDownIcon, ChevronUpIcon, MessageSquareIcon } from 'lucide-react';
export function CustomerReviews() {
  const [expandedReview, setExpandedReview] = useState<number | null>(null);
  const reviews = [{
    id: 1,
    name: 'Sarah M.',
    date: 'August 2023',
    rating: 5,
    title: 'Absolutely magical experience!',
    content: "This tour was the highlight of our trip to Santorini. Our guide Dimitri was incredibly knowledgeable about the island's history and wine culture. The winery visit was informative and the wines were excellent - I especially enjoyed the Assyrtiko! The sunset view was absolutely breathtaking and Dimitri knew exactly where to take us to avoid the crowds in Oia. Highly recommend this tour for anyone visiting Santorini!",
    helpful: 24,
    photos: ['https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&q=80']
  }, {
    id: 2,
    name: 'James L.',
    date: 'July 2023',
    rating: 4,
    title: 'Great tour, but a bit rushed',
    content: 'The tour itself was wonderful - beautiful locations, excellent wine tasting, and an amazing sunset. Our guide was friendly and informative. My only complaint is that we felt a bit rushed at the winery. Would have loved another 30 minutes to really enjoy the experience. That said, still a great way to see Santorini and I would recommend it.',
    helpful: 12,
    photos: []
  }, {
    id: 3,
    name: 'Maria K.',
    date: 'September 2023',
    rating: 5,
    title: 'Perfect way to experience Santorini',
    content: "From start to finish, this tour was exceptional. The small group size made it feel personal and our guide Christina was fantastic - so passionate about Santorini and its wines. The winery we visited had stunning views of the caldera and the wine tasting was generous and delicious. The sunset spot was perfect and Christina helped everyone get great photos. The transportation was comfortable and on-time. Couldn't have asked for a better experience!",
    helpful: 18,
    photos: ['https://images.unsplash.com/photo-1601755114385-4301d48ae0f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&q=80', 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=300&q=80']
  }];
  const renderStars = (rating: number) => {
    return Array(5).fill(0).map((_, i) => <StarIcon key={i} size={16} className={i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'} data-id="element-222" />);
  };
  return <section className="py-8" data-id="element-223">
      <div className="container mx-auto px-4" data-id="element-224">
        <div className="flex items-center justify-between mb-6" data-id="element-225">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-226">
            Customer Reviews{' '}
            <span className="text-sm font-normal text-gray-500" data-id="element-227">(324)</span>
          </h2>
          <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700" data-id="element-228">
            <MessageSquareIcon size={16} className="mr-2" data-id="element-229" />
            Write a Review
          </button>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mb-6" data-id="element-230">
          <div className="p-4 flex items-center border-b border-gray-200" data-id="element-231">
            <div className="mr-4" data-id="element-232">
              <div className="text-3xl font-bold text-gray-900" data-id="element-233">4.8</div>
              <div className="flex mt-1" data-id="element-234">{renderStars(5)}</div>
            </div>
            <div className="flex-grow" data-id="element-235">
              <div className="grid grid-cols-5 gap-2" data-id="element-236">
                {[5, 4, 3, 2, 1].map(star => <div key={star} className="col-span-1 flex items-center" data-id="element-237">
                    <span className="text-sm text-gray-600 mr-2" data-id="element-238">{star}</span>
                    <div className="flex-grow bg-gray-200 rounded-full h-2 overflow-hidden" data-id="element-239">
                      <div className="bg-yellow-400 h-2 rounded-full" style={{
                    width: star === 5 ? '80%' : star === 4 ? '15%' : star === 3 ? '3%' : star === 2 ? '1%' : '1%'
                  }} data-id="element-240"></div>
                    </div>
                  </div>)}
              </div>
            </div>
          </div>
          <div className="p-4 border-b border-gray-200 bg-gray-50" data-id="element-241">
            <div className="flex flex-wrap gap-2" data-id="element-242">
              <button className="px-3 py-1.5 bg-white border border-gray-300 rounded-full text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-243">
                All Reviews
              </button>
              <button className="px-3 py-1.5 bg-white border border-gray-300 rounded-full text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-244">
                5 Star
              </button>
              <button className="px-3 py-1.5 bg-white border border-gray-300 rounded-full text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-245">
                With Photos
              </button>
              <button className="px-3 py-1.5 bg-white border border-gray-300 rounded-full text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-246">
                Most Recent
              </button>
              <button className="px-3 py-1.5 bg-white border border-gray-300 rounded-full text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-247">
                Most Helpful
              </button>
            </div>
          </div>
          <div data-id="element-248">
            {reviews.map(review => <div key={review.id} className="p-4 border-b border-gray-200 last:border-b-0" data-id="element-249">
                <div className="flex items-start justify-between mb-3" data-id="element-250">
                  <div data-id="element-251">
                    <div className="flex items-center" data-id="element-252">
                      <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-700 font-medium mr-3" data-id="element-253">
                        {review.name.charAt(0)}
                      </div>
                      <div data-id="element-254">
                        <h3 className="font-medium text-gray-900" data-id="element-255">
                          {review.name}
                        </h3>
                        <div className="flex items-center mt-1" data-id="element-256">
                          {renderStars(review.rating)}
                          <span className="ml-2 text-sm text-gray-500" data-id="element-257">
                            {review.date}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h4 className="font-medium text-gray-900 mb-2" data-id="element-258">
                  {review.title}
                </h4>
                <div className={expandedReview === review.id ? '' : 'line-clamp-3'} data-id="element-259">
                  <p className="text-gray-700" data-id="element-260">{review.content}</p>
                </div>
                {review.content.length > 150 && <button className="mt-2 text-sm font-medium text-blue-600 hover:text-blue-800 flex items-center" onClick={() => setExpandedReview(expandedReview === review.id ? null : review.id)} data-id="element-261">
                    {expandedReview === review.id ? <>
                        <span data-id="element-262">Read less</span>
                        <ChevronUpIcon size={16} className="ml-1" data-id="element-263" />
                      </> : <>
                        <span data-id="element-264">Read more</span>
                        <ChevronDownIcon size={16} className="ml-1" data-id="element-265" />
                      </>}
                  </button>}
                {review.photos.length > 0 && <div className="mt-3 flex gap-2" data-id="element-266">
                    {review.photos.map((photo, index) => <div key={index} className="w-16 h-16 rounded-lg overflow-hidden" data-id="element-267">
                        <img src={photo} alt={`Review photo by ${review.name}`} className="w-full h-full object-cover" data-id="element-268" />
                      </div>)}
                  </div>}
                <div className="mt-3 flex items-center" data-id="element-269">
                  <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-270">
                    Helpful ({review.helpful})
                  </button>
                  <span className="mx-2 text-gray-300" data-id="element-271">|</span>
                  <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-272">
                    Report
                  </button>
                </div>
              </div>)}
          </div>
          <div className="p-4 border-t border-gray-200 bg-gray-50 text-center" data-id="element-273">
            <button className="text-blue-600 hover:text-blue-800 font-medium" data-id="element-274">
              See all 324 reviews
            </button>
          </div>
        </div>
      </div>
    </section>;
}